import type { CalculationResponse } from '../gen/ejot/roofing/v1/types';

/**
 * A calculation may fail engineering verification and still be a perfectly
 * usable visual source. Only responses that could not be calculated at all are
 * excluded from the last-valid visual cache.
 */
export function isUsableVisualResult(result: CalculationResponse | undefined): result is CalculationResponse {
  if (!result) return false;
  return result.status !== 'CALCULATION_STATUS_BLOCKED'
    && result.status !== 'CALCULATION_STATUS_NOT_CALCULATED'
    && result.status !== 'CALCULATION_STATUS_UNSPECIFIED';
}

/**
 * Selects the visual result independently from the current engineering verdict.
 * Current calculable responses always win. While a request is pending, failed,
 * or blocked, the last calculable response remains available for 2D/3D visual
 * continuity and is explicitly marked stale by the caller.
 */
export function selectVisualResult(
  current: CalculationResponse | undefined,
  lastValid: CalculationResponse | undefined,
): { result: CalculationResponse | undefined; stale: boolean } {
  if (isUsableVisualResult(current)) return { result: current, stale: false };
  if (lastValid) return { result: lastValid, stale: true };
  return { result: undefined, stale: false };
}
